"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/naming-convention,@typescript-eslint/no-unsafe-member-access */
const DependencyError_1 = require("../../Error/DependencyError");
class ViewFinder {
    constructor(framework) {
        this.framework = framework;
    }
    /**
     * Get a sub-view with the given view class. Example: `this.getView(WarehouseListView);`
     *
     * @param el the element to look within
     * @param ViewClass the class to instantiate
     * @param args Pass any extra arguments to the View
     * @throws Error when view can't be found
     */
    getView(el, ViewClass, ...args) {
        try {
            const element = el.query(`[data-view="${Object.getPrototypeOf(ViewClass).name}"]`);
            if (this.framework.hasView(element)) {
                return this.framework.getView(element);
            }
            ViewClass.prototype.$target = element;
            // in certain cases args can be undefined
            // istanbul ignore next
            return args === undefined ? new ViewClass() : new ViewClass(...args);
            // intentionally catch all exceptions to enrich the message
        }
        catch (e) {
            if (e instanceof DependencyError_1.default) {
                throw e;
            }
            // istanbul ignore next
            throw e instanceof Error ? new Error(`${e.message}. Verify you have @component attribute on your view`) : e;
        }
    }
    /**
     * Try to get a sub-view that might not exist. The promise will resolve when the view exists or rejected when it doesn't
     *
     * @param el the element to look within
     * @param ViewClass the class to instantiate
     * @param args Pass any extra arguments to the View
     * @throws Error when view can't be found
     */
    getViewPromise(el, ViewClass, ...args) {
        return new Promise((resolve, reject) => {
            const selector = `[data-view="${Object.getPrototypeOf(ViewClass).name}"]`;
            const target = el.querySelector(selector);
            if (target === null) {
                reject();
                return;
            }
            if (this.framework.hasView(target)) {
                resolve(this.framework.getView(target));
                return;
            }
            ViewClass.prototype.$target = target;
            resolve(new ViewClass(...args));
        });
    }
    /**
     * Try to get a sub-view that might not exist. The method will return the view when it exists or null when it doesn't
     *
     * @param el the element to look within
     * @param ViewClass the class to instantiate
     * @param args Pass any extra arguments to the View
     */
    getViewOrNull(el, ViewClass, ...args) {
        try {
            return this.getView(el, ViewClass, args);
        }
        catch (e) {
            if (e instanceof DependencyError_1.default) {
                throw e;
            }
            return null;
        }
    }
    /**
     * Get a set of sub-views. `this.getViews(WarehouseListView);`
     */
    getViews(el, ViewClass, ...args) {
        const elements = el.querySelectorAll(`[data-view="${Object.getPrototypeOf(ViewClass).name}"]`);
        const views = [];
        elements.forEach((viewElement) => {
            if (this.framework.hasView(viewElement)) {
                views.push(this.framework.getView(viewElement));
                return;
            }
            ViewClass.prototype.$target = viewElement;
            views.push(args === undefined || args.length === 0 ? new ViewClass() : new ViewClass(...args));
        });
        return views;
    }
}
exports.default = ViewFinder;
//# sourceMappingURL=ViewFinder.js.map